<script>
    // Aangepast van weerstation: GEEN WATERMERK
    import { Line, mixins } from 'vue-chartjs';

    const { reactiveProp } = mixins;

    export default {
        extends: Line,
        mixins: [reactiveProp],
        data () {
            return {
                // Chart.js options that control the appearance of the chart
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: true,
                        position: 'right',
                        labels: {
                            boxWidth: 20,
                        },
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                            },
                            gridLines: {
                                display: true,
                            },
                        }],
                        xAxes: [{
                            gridLines: {
                            },
                            ticks: {
                                autoSkip: false,
                                callback: function(dataLabel, index) {
                                    if (dataLabel.substring(11,16) == "00:00" ||
                                      dataLabel.substring(11,16) == "06:00" ||
                                      dataLabel.substring(11,16) == "12:00" ||
                                      dataLabel.substring(11,16) == "18:00") {
                                      return dataLabel;
                                    } else {
                                      return undefined;
                                    }

                                }
                            }
                        }],
                    },
                  elements: {
                        point: {
                            radius: 0,
                            hitRadius: 10,
                            hoverRadius: 4,
                            hoverBorderWidth: 3,
                        },
                    },
                },
            };
        },
        mounted () {
            // this.chartData is created in the mixin and
            // contains all the data needed to build the chart
            this.renderChart(this.chartData, this.options);
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/weerstation/LineChartR0.vue